import api from "../api";


export const getUsers = async (data : {
    page : number,
    page_size : number,
    search : string,
    ordering : string,
}) => {
    const res : any = await api.get("member/", { 
        params : {...data, is_coach : false} 
    })
    return res.data
}

export const exportUsers = async () => {
    const res = await api.post("admin/users/export/")
    return res.data as { success: boolean; task_id: string; message: string }
}

export const getUserExportStatus = async (taskId : string) => {
    const res = await api.get(`admin/users/export/status/${taskId}/`)
    return res.data as
        | { status: 'PENDING'; message: string }
        | { status: 'PROGRESS'; progress: number; message: string }
        | { status: 'SUCCESS'; download_url: string; filename: string; message: string }
        | { status: 'FAILURE'; error: string; message: string }
}

export const deletePost = async (data : {
    id : string,
}) => {
    const res = await api.delete(`post/${data.id}`)
    return res.data
}

export const postUser = async (data : {
    email : string,
    password : string,
    full_name : string,
    phone_number : string,

    promotion_opt_in : boolean,
    emergency_contact_name : string,
    emergency_contact_phone : string,

}) => {
    const res = await api.post("user/", {...data, 
    
        phone_number : undefined,
        promotion_opt_in : undefined,
        emergency_contact_name : undefined,
        emergency_contact_phone : undefined,
    })
    return res.data
}

export const deleteUserProfile = async () => {
    const res = await api.delete("user/")
    return res.data
}

export const deleteUser = async (data : {
    id : string,
    
}) => {
    const res = await api.patch(`member/${data.id}/manage`, { is_active : false })
    return res.data
}   

export const activateUser = async (data : {
    id : string,
    
}) => {
    const res = await api.patch(`member/${data.id}/manage`, { is_active : true })
    return res.data
}   


export const getUserReports = async (data : {
    page : number,
    page_size : number,
    type : string,
    ordering ?: string,
}) => {
    const res : any = await api.get("admin/support/reports/", { 
        params : data
    })
    return res.data
}

export const putUserReport = async (data : {
    id : string,
}) => {
    const res = await api.put(`admin/support/reports/${data.id}/resolve/`, { resolved : true })
    return res.data
}

export const getClassBookings = async (data : {
    page : number,
    page_size : number,
    member_ids ?: string,
    ordering ?: string,
}) => {
    const res : any = await api.get("admin/private_classes/bookings/", { 
        params : data
    })
    return res.data
}

export const getEventsBookings = async (data : {
    page : number,
    page_size : number,
    member_ids ?: string,
    ordering ?: string,
}) => {
    const res : any = await api.get("admin/events/bookings/", { 
        params : data
    })
    return res.data
}

